import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Banner from '../components/Banner'
import ComodityBuy from '../components/forms/ComodityBuy'


const Commodity = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='Commodity Direct Buyers Entry' text='Please complete the registration form' />
            <ComodityBuy />
            <Banner />
            <Footer />
        </div>
    )
}

export default Commodity;
